import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// API
import * as API from '../../../utils/api';

// Actions
import {
  updateActiveProfile
} from '../../../actions/activeProfile'

// Components
import Header from '../../../components/Global/Header';
import AccountSettingsNav from '../../../components/UserPortal/AccountSettings/AccountSettingsNav';
import FormContainer from '../../../components/Global/FormContainer';
import FlashMessage from '../../../components/Global/FlashMessage';

class CancelSubscription extends Component {
  state = {
    flashMessage: {
      type: '',
      message: '',
    },
    displayFlashMessage: false,
    redirectUrl: null,
  }

  renderFlashMessage() {
    const {
      displayFlashMessage,
      flashMessage
    } = this.state;

    return displayFlashMessage
    ? (
      <FlashMessage optionalClasses={flashMessage.type === 'error' ? 'error' : ''}>
        {flashMessage.message}
      </FlashMessage>
    ) : null
  }

  handleCancel = () => {
    const { user, activeProfile } = this.props
    const message = encodeURI('Your subscription has been cancelled!')
    const redirectUrl = `/settings/payment-info?message=${message}`

    API.cancelSubscription(user, activeProfile.username)
    .then(response => {
      if (response.error) {
        console.log('there was an error: ', response.error);
      } else {
        this.setState({ redirectUrl })
      }
    }).catch(error => {
      console.log('there was an error: ', error);
    });
  }

  render() {
    const { path, appName, activeProfile } = this.props;
    const { redirectUrl } = this.state;


    // TO DO: UPDATE ACTIVE PROFILE SCUBSCRIPTION STATUS ON REDIRECT
    console.log('activeProfile: ', activeProfile)

    if (redirectUrl) {
      return <Redirect to={redirectUrl} />
    }

    return (
      <div
        className="user-portal account-settings cancel-subscription">
        <Helmet>
          <title>{appName} | Settings – Cancel Subscription</title>
        </Helmet>
        <Header path={ path } />
        <AccountSettingsNav currentTab="payment-info" />
        <FormContainer>
          <header>
            <h1>Are you sure?</h1>
          </header>
          <p>
            Are you sure you want to cancel your paid subscription? Keep in mind you will lose all access to the premier features you've been using.
          </p>
          <p>
            If you still decide you want to cancel, your premier account will remain active until the end of the current billing period, and you will no longer be charged beyond that.
          </p>
          <button
            type="button"
            onClick={this.handleCancel}
            className="cta full-width cta-gradient"
          >
            Confirm Cancellation
          </button>
          <Link
            to="/settings/payment-info/"
            className="cta full-width invert"
          >
            Go Back
          </Link>
        </FormContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateActiveProfile: (user, username, profile) => dispatch(updateActiveProfile(user, username, profile))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelSubscription)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Settings/CancelSubscription.js